'use strict';

var react = require('react');

const emptySubscribe = () => () => {
};
function useIsSSR() {
  const isSSR = react.useSyncExternalStore(
    emptySubscribe,
    () => false,
    () => true
  );
  return isSSR;
}

exports.useIsSSR = useIsSSR;
//# sourceMappingURL=useIsSSR.cjs.map
